export interface LegacyAddToCartRequest {
  idiq: number;
  quantity: number;
  getCart: boolean;
  referringUrl: string;
  useAbTest: boolean;
  jitOffer?: string;
}

export interface LegacyUpdateCartQuantityRequest {
  idiq: number;
  quantity: number;
}

export type CartMessage =
  | "Success"
  | "NotInStock"
  | "NotEnoughInventory"
  | "DBUpdateFailed"
  | "ItemNotFound"
  | "";

export interface LegacyCartResponse {
  /** True if there was an error modifying the cart */
  Error: boolean;

  /** The message tied to the Error */
  Message: CartMessage;

  /** Cart ID */
  ID: number;

  Analytics: object | null;

  /** The items within the cart */
  CartItems: LegacyCartItem[];
  CartCollectibles: object[];
  Total: number;

  /** Subtotal of eligible items toward meeting the free shipping hurdle */
  FreeShippingProgressSubtotal: number;

  /** The ship hurdle */
  FreeShippingThreshold: number;

  HasEligibleFreeShippingItems: boolean;
  HasIneligibleFreeShippingItems: boolean;
  IsMixedEligibilityCart: boolean;

  /** Legacy experiment variant used by the added-to-cart shipping treatment. */
  AbTestVariant?: string | null;

  /** Add-on offer batch that uses the Legacy add-to-cart interstitial. */
  BatchId?: number;

  /** Total number of book credits applicable to the current cart */
  AvailableBookCredits: number;

  /** Total number of book credits available to the user */
  TotalAvailableBookCredits: number;

  /** Number of book credits applied to this cart */
  AppliedBookCredits: number;

  /** Dollar amount of the book credit(s) */
  BookCreditValue: number;

  /** The total number of items within this cart, incl. collectibles */
  CartTotalItemQuantity: number;
}

export interface LegacyCartItem {
  IdInventoryQuality: number;
  IdAmazon: number;
  IdWork: number;
  IdList: number;
  Title: string;
  CleanUrl: string;
  Isbn: string;
  Price: number;
  Author?: string;
  Condition?: string;
  Format?: string;
  MediumImageUrl?: string;
  Quantity?: number;
  ShippingSurcharge?: number;
}

/**
 * Represents an error when adding an item to the cart
 */
export class CartError extends Error {
  constructor(
    message: string,
    /** The error returned by the cart API */
    public cartMessage: CartMessage,
  ) {
    super(message);
    this.name = "CartError";
  }
}
